module.exports = __webpack_public_path__ + "img/section6.b8b93d22.svg";